import { first, get, isEmpty } from "lodash"
import { IKioskConfigRecord } from "services/venue"
import { IKioskConfigData } from "../interface"
import { parseEntries } from "providers/venue/utils/prepareEntry"

export const prepareKioskConfig = (
  entries: IKioskConfigRecord[]
): IKioskConfigData => {
  if (isEmpty(entries)) return {} as IKioskConfigData

  // Group and normalize the data
  const parsedEntries = parseEntries(get(entries, "data"))
  const firstRecord = first(parsedEntries)
  const { name, device_latitude, device_longitude, ordinal, ...rest } =
    firstRecord
  const locationName = name?.en
  // Attach `locationName` and `deviceLocation` fields to the kiosk configuration result.
  return {
    locationName,
    deviceLocation: `${device_longitude},${device_latitude},${ordinal}o`,
    source: {
      name: locationName,
      device_latitude,
      device_longitude,
      ordinal,
      ...rest,
    },
  }
}
